<template>
  <div id="wt-sidebar">
    <ul>
      <li v-if="enabledItems != ''" id="exit-item">
        <router-link :to="{name: 'system-menu'}">
          <i class="fas fa-sign-out-alt mx-2 wt-sidebar-fa" id="exit-ico"></i>
          <span class="wt-sidebar-desc">Exit {{activeSystem}}</span>
        </router-link>
      </li>
      <li v-if="enabledItems.includes('home-bpm')">
        <router-link :to="{name: 'bpm_home'}">
          <i class="fas fa-home mx-2 wt-sidebar-fa"></i>
          <span class="wt-sidebar-desc">Home</span>
        </router-link>
      </li>
      <li v-if="enabledItems.includes('home-streamline')">
        <router-link :to="{name: 'home'}">
          <i class="fas fa-home mx-2 wt-sidebar-fa"></i>
          <span class="wt-sidebar-desc">Home</span>
        </router-link>
      </li>
      <!-- Single button triggers two "<b-collapse>" components -->
      <li
        v-if="enabledItems.includes('security-credential') || 
              enabledItems.includes('security-provider') || 
              enabledItems.includes('security-role')"
      >
        <a v-b-toggle.collapse-a.collapse-b @click="securyVisible = !securyVisible">
          <i class="fas fa-shield-alt mx-2 wt-sidebar-fa"></i>
          <span class="wt-sidebar-desc" v-show="securyVisible">
            Security
            <i class="fas fa-caret-up"></i>
          </span>
          <span class="wt-sidebar-desc" v-show="!securyVisible">
            Security
            <i class="fas fa-caret-down"></i>
          </span>
        </a>

        <ul>
          <!-- Elements to collapse -->
          <b-collapse id="collapse-a" v-if="enabledItems.includes('security-credential')">
            <li>
              <router-link :to="{name: 'security-credential'}">
                <i class="fas fa-user-tag mx-2 wt-sidebar-fa"></i>
                <span class="wt-sidebar-desc">Security Credential</span>
              </router-link>
            </li>
          </b-collapse>
          <b-collapse id="collapse-b" v-if="enabledItems.includes('security-provider')">
            <li>
              <router-link :to="{name: 'security-provider'}">
                <i class="fas fa-handshake mx-2 wt-sidebar-fa"></i>
                <span class="wt-sidebar-desc">Security Provider</span>
              </router-link>
            </li>
          </b-collapse>
          <b-collapse id="collapse-b" v-if="enabledItems.includes('security-role')">
            <li>
              <router-link :to="{name: 'security-role'}">
                <i class="fas fa-cogs mx-2 wt-sidebar-fa"></i>
                <span class="wt-sidebar-desc">Security Role</span>
              </router-link>
            </li>
          </b-collapse>
        </ul>
      </li>
      <li v-if="enabledItems.includes('scheduler')">
        <router-link :to="{name: 'scheduler'}">
          <i class="far fa-clock mx-2 wt-sidebar-fa"></i>
          <span class="wt-sidebar-desc">Scheduler</span>
        </router-link>
      </li>
      <li v-if="enabledItems.includes('queue')">
        <router-link :to="{name: 'queue'}">
          <i class="fas fa-th-list mx-2 wt-sidebar-fa"></i>
          <span class="wt-sidebar-desc">Queue</span>
        </router-link>
      </li>
      <li v-if="enabledItems.includes('resource')">
        <router-link :to="{name: 'resource'}">
          <i class="fab fa-buffer mx-2 wt-sidebar-fa"></i>
          <span class="wt-sidebar-desc">Resource</span>
        </router-link>
      </li>
      <li v-if="enabledItems.includes('modelo')">
        <router-link :to="{name: 'modelo'}">
          <i class="fas fa-life-ring mx-2 wt-sidebar-fa"></i>
          <span class="wt-sidebar-desc">Modelo</span>
        </router-link>
      </li>
      <li v-if="enabledItems.includes('service-doc')">
        <router-link :to="{name: 'service-doc'}">
          <i class="fas fa-book mx-2 wt-sidebar-fa"></i>
          <span class="wt-sidebar-desc">Service Doc</span>
        </router-link>
      </li>
      <li v-if="enabledItems.includes('service-doc-search')">
        <router-link :to="{name: 'service-doc-search'}">
          <i class="fas fa-search mx-2 wt-sidebar-fa"></i>
          <span class="wt-sidebar-desc">Doc Search</span>
        </router-link>
      </li>
      <li v-if="enabledItems.includes('bpm_process')">
        <router-link :to="{name: 'bpm_process'}">
          <i class="fas fa-tasks mx-2 wt-sidebar-fa"></i>
          <span class="wt-sidebar-desc">BPM Process</span>
        </router-link>
      </li>
      <li v-if="enabledItems.includes('support-ticket')">
        <router-link :to="{name: 'support-ticket'}">
          <i class="fab fa-accusoft mx-2 wt-sidebar-fa"></i>
          <span class="wt-sidebar-desc">Support Ticket</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      securyVisible: false,
      enabledItems: []
    };
  },
  name: "wt-sidebar",
  components: {},
  props: {},
  computed: {
    activeSystem() {
      return this.$store.state.activeSystem;
    }
  },
  methods: {
    enabledItemsList() {
      this.activeSystem === "";
      if (this.activeSystem === "Streamline") {
        this.enabledItems = [
          "home-streamline",
          "security-credential",
          "security-provider",
          "security-role",
          "scheduler",
          "queue",
          "resource",
          "modelo",
          "service-doc",
          "service-doc-search",
          "support-ticket"
        ];
      }
      if (this.activeSystem === "BPM") {
        this.enabledItems = [
          "home-bpm",
          "security-role",
          "scheduler",
          "queue",
          "bpm_process"
        ];
      }
    }
  },
  mounted() {
    this.securyVisible = false;
    this.enabledItemsList();
  },
  watch: {
    activeSystem() {
      this.enabledItemsList();
    }
  }
};
</script>
<style>
</style>